import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent, SvgElement } from '../../../shared/index.js';

import { IContainerConfiguration, IContainerProps, IContainerState } from './models/index.js';
import { CONTAINER_CATEGORY_KEY, CONTAINER_COMPONENT_KEY } from './Container.meta.js';

export class Container extends SvgElement<IContainerProps, IContainerState, IContainerConfiguration> {
	categoryKey = CONTAINER_CATEGORY_KEY;
	componentKey = CONTAINER_COMPONENT_KEY;

	constructor(props: IContainerProps) {
		super(props);
	}
	render() {
		const { className, children } = this.props;
		const props = this.getElementSvgProps<SVGSVGElement>();
		return (
			<svg xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
				{children}
			</svg>
		);
	}
}

export default InjectedStyledComponent(observer(Container), CONTAINER_CATEGORY_KEY, CONTAINER_COMPONENT_KEY);
